import React from 'react'
import { FaUserFriends } from 'react-icons/fa';

export default function Nav() {
    //#E3E3E3
  return (
    <div className=' w-full min-h-[10vh] p-[1em] bg-[#1E2029]'>
        <div className=' flex gap-2
        '>
        <FaUserFriends size={25} color="#9a6aff" />

            <p className=' font-[Righteous] text-xl text-white'>HRXpert</p>
        </div>

    </div>
  )
}
